import setIsNewRecord from './setIsNewRecord';
import toggleModalProduct from './toggleModalProduct';

export default () => (dispatch) => {
    dispatch(setIsNewRecord(true));
    dispatch(toggleModalProduct(true));
};
